"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultHistoryAccountSubscriber = void 0;
const types_1 = require("./types");
const events_1 = require("events");
const addresses_1 = require("../addresses");
const webSocketAccountSubscriber_1 = require("./webSocketAccountSubscriber");
class DefaultHistoryAccountSubscriber {
    constructor(program) {
        this.isSubscribed = false;
        this.program = program;
        this.eventEmitter = new events_1.EventEmitter();
    }
    subscribe() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isSubscribed) {
                return true;
            }
            const statePublicKey = yield addresses_1.getClearingHouseStateAccountPublicKey(this.program.programId);
            const state = yield this.program.account.state.fetch(statePublicKey);
            this.tradeHistoryAccountSubscriber = new webSocketAccountSubscriber_1.WebSocketAccountSubscriber('tradeHistory', this.program, state.tradeHistory);
            yield this.tradeHistoryAccountSubscriber.subscribe((data) => {
                this.eventEmitter.emit('tradeHistoryAccountUpdate', data);
                this.eventEmitter.emit('update');
            });
            this.depositHistoryAccountSubscriber = new webSocketAccountSubscriber_1.WebSocketAccountSubscriber('depositHistory', this.program, state.depositHistory);
            yield this.depositHistoryAccountSubscriber.subscribe((data) => {
                this.eventEmitter.emit('depositHistoryAccountUpdate', data);
                this.eventEmitter.emit('update');
            });
            this.fundingPaymentHistoryAccountSubscriber =
                new webSocketAccountSubscriber_1.WebSocketAccountSubscriber('fundingPaymentHistory', this.program, state.fundingPaymentHistory);
            yield this.fundingPaymentHistoryAccountSubscriber.subscribe((data) => {
                this.eventEmitter.emit('fundingPaymentHistoryAccountUpdate', data);
                this.eventEmitter.emit('update');
            });
            this.fundingRateHistoryAccountSubscriber = new webSocketAccountSubscriber_1.WebSocketAccountSubscriber('fundingRateHistory', this.program, state.fundingRateHistory);
            yield this.fundingRateHistoryAccountSubscriber.subscribe((data) => {
                this.eventEmitter.emit('fundingRateHistoryAccountUpdate', data);
                this.eventEmitter.emit('update');
            });
            this.liquidationHistoryAccountSubscriber = new webSocketAccountSubscriber_1.WebSocketAccountSubscriber('liquidationHistory', this.program, state.liquidationHistory);
            yield this.liquidationHistoryAccountSubscriber.subscribe((data) => {
                this.eventEmitter.emit('liquidationHistoryAccountUpdate', data);
                this.eventEmitter.emit('update');
            });
            this.curveHistoryAccountSubscriber = new webSocketAccountSubscriber_1.WebSocketAccountSubscriber('curveHistory', this.program, state.curveHistory);
            yield this.curveHistoryAccountSubscriber.subscribe((data) => {
                this.eventEmitter.emit('curveHistoryAccountUpdate', data);
                this.eventEmitter.emit('update');
            });
            this.eventEmitter.emit('update');
            this.isSubscribed = true;
            return true;
        });
    }
    unsubscribe() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.isSubscribed) {
                return;
            }
            yield this.tradeHistoryAccountSubscriber.unsubscribe();
            yield this.fundingRateHistoryAccountSubscriber.unsubscribe();
            yield this.fundingPaymentHistoryAccountSubscriber.unsubscribe();
            yield this.depositHistoryAccountSubscriber.unsubscribe();
            yield this.curveHistoryAccountSubscriber.unsubscribe();
            yield this.liquidationHistoryAccountSubscriber.unsubscribe();
            this.isSubscribed = false;
        });
    }
    assertIsSubscribed() {
        if (!this.isSubscribed) {
            throw new types_1.NotSubscribedError('You must call `subscribe` before using this function');
        }
    }
    getTradeHistoryAccount() {
        this.assertIsSubscribed();
        return this.tradeHistoryAccountSubscriber.data;
    }
    getDepositHistoryAccount() {
        this.assertIsSubscribed();
        return this.depositHistoryAccountSubscriber.data;
    }
    getFundingPaymentHistoryAccount() {
        this.assertIsSubscribed();
        return this.fundingPaymentHistoryAccountSubscriber.data;
    }
    getFundingRateHistoryAccount() {
        this.assertIsSubscribed();
        return this.fundingRateHistoryAccountSubscriber.data;
    }
    getCurveHistoryAccount() {
        this.assertIsSubscribed();
        return this.curveHistoryAccountSubscriber.data;
    }
    getLiquidationHistoryAccount() {
        this.assertIsSubscribed();
        return this.liquidationHistoryAccountSubscriber.data;
    }
}
exports.DefaultHistoryAccountSubscriber = DefaultHistoryAccountSubscriber;
